// modules
import { createAction } from 'redux-actions'
// setup
import { dispatch } from '../../setup/redux'

export const RESET_WAPP_STACK = 'RESET_WAPP_STACK'
const resetWappStack = createAction(RESET_WAPP_STACK)
export const dispatchResetWappStack = (...args) =>
  dispatch(resetWappStack(...args))

export const PUSH_WAPP_STACK = 'PUSH_WAPP_STACK'
const pushWappStack = createAction(PUSH_WAPP_STACK)
export const dispatchPushWappStack = (...args) =>
  dispatch(pushWappStack(...args))

export const POP_WAPP_STACK = 'POP_WAPP_STACK'
const popWappStack = createAction(POP_WAPP_STACK)
export const dispatchPopWappStack = (...args) => dispatch(popWappStack(...args))

export const SET_CURRENT_IN_WAPP_STACK = 'SET_CURRENT_IN_WAPP_STACK'
const setCurrentInWappStack = createAction(SET_CURRENT_IN_WAPP_STACK)
export const dispatchSetCurrentInWappStack = (...args) =>
  dispatch(setCurrentInWappStack(...args))
